<template>
  <div>
    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5 " outlined>
      <v-row align="center" class="mt-2 mr-2">
        <v-col class="d-flex" cols="12" sm="6"></v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select
            v-model="daterange"
            :items="dateRanges"
            label="DATE RANGE"
            dense
            outlined
            @change="filterMonthlysalesplanpiechart()"
          ></v-select>
        </v-col>
      </v-row>
      <highcharts :options="chartOptions" ref="highcharts"></highcharts>
      <!--<button @click="updateCredits">update credits</button>-->
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapGetters, mapActions } from "vuex";

import { VUE_APP_BASEURL } from "../utils/api";
import axios from "axios";
import store from "../store";

export default {
  name: "MonthlySalesPlanPieChart",
  props: [
    "selectedsegment",
    "selectedsalesengineer",
    "selectedregion",
    "selectedproductgroup"
  ],
  data: () => ({
    daterange: "",
    chartOptions: {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie"
      },
      title: {
        text: "MONTHLY SALES PLAN"
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.y}</b>"
      },
      accessibility: {
        point: {
          valueSuffix: "%"
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
            format: "<b>{point.name}: <b>{point.y}</b>"
          },
          showInLegend: true
        }
      },
      series: [
        {
          name: "",
          colorByPoint: true,
          data: [{}]
        }
      ],
      credits: {
        enabled: false
      }
    }
  }),
  components: {},
  computed: {
    ...mapGetters(["getDateRange"]),
    dateRanges: function() {
      return this.getDateRange;
    }
  },
  mounted() {
    /*   setTimeout(() => {
        this.chartOptions.series[0].data=this.chartData.monthlySalesplanpiechartData;
     //   console.log('updated');
        }, 3000)*/
  },
  created() {
    this.fetchDefinedvalues();
    this.monthlysalesplanchartload(this.chartOptions);
  },
  methods: {
    ...mapActions(["fetchDefinedvalues"]),

    monthlysalesplanchartload(chartOptions) {
      const filterData = [];

      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "chart/monthlysalesplan-chart-data",
        data: {
          product: filterData.product,
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          status: filterData.status,
          region: filterData.region,
          productgroup: filterData.productgroup,
          daterange: filterData.daterange
        }
      })
        .then(function(response) {
          chartOptions.series[0].data =
            response.data.response.monthlySalesplanpiechartData;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    filterMonthlysalesplanpiechart() {
      const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
        daterange: this.daterange,
        region: this.selectedregion,
        productgroup: this.selectedproductgroup,
        product: "",
        status: ""
      };
      const chartOptions = this.chartOptions;
      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "chart/monthlysalesplan-chart-data",
        data: {
          product: filterData.product,
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          status: filterData.status,
          region: filterData.region,
          productgroup: filterData.productgroup,
          daterange: filterData.daterange
        }
      })
        .then(function(response) {
          //console.log(response);

          chartOptions.series[0].data =
            response.data.response.monthlySalesplanpiechartData;
        })
        .catch(function(error) {
          console.log(error);
          console.log(error.response);
        });
    }
  }
};
</script>
